import React, {useState, useRef, useEffect} from 'react';
import styled from 'styled-components';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap/dist/js/bootstrap';
import CustomInput from 'components/CustomInput';
import { getCommunity } from 'helpers/community';
import CustomSelect from 'components/CustomSelect';

const AddManualMovementModalStyled = styled.div`

    .modal {
	    background: rgba(0, 0, 0, 0.4);
    }
`;

let axiosCancelToken = null;

const AddManualMovementModal = (props) => {
    const treasuryId = props.treasuryId;
    const closeCallback = props.onClose;

    const [data, setData] = useState({
        date: moment().format('YYYY-MM-DD'),
        amount: '',
        concept: ''
    });
    const [type, setType] = useState('expense');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const modalRef = useRef(null);
    const datesToUpdateRef = useRef([]);

    useEffect(() => {
        axiosCancelToken = axios.CancelToken.source();

        return function cleanup() {
            axiosCancelToken.cancel();
        }
    }, []);

    useEffect(() => {
        const modal = new Modal(modalRef.current, {backdrop: false, keyboard: false});

        const hiddenEvent = (e) => {
            if ( e.target !== modal._element ) return; // Fix to avoid close when a child modal is closed

            modal._element.removeEventListener('hidden.bs.modal', hiddenEvent);
            modal._element.removeEventListener('shown.bs.modal', hiddenEvent);
            modal.dispose();

            closeCallback(datesToUpdateRef.current);

            // Fix, because bootstrap removes scroll and add padding on modal opened
            document.body.style.overflow = 'auto'; 
            document.body.style.paddingRight = '0';
        }

        modal._element.addEventListener('hidden.bs.modal', hiddenEvent);
        modal.show();	
    }, [closeCallback]);

    const hideModal = () => {
        Modal.getInstance(modalRef.current).hide();
    }

    const setDataField = (field, value) => {
		setData({...data, [field]: value});
	}

    const saveData = async () => {
        // Set datesToUpdateRef
        datesToUpdateRef.current = [data.date];

        // Save
        setLoading(true);
        await axios.post('/api/manager/bank-reconciliation/add-manual-bankmovement', {
            community_id: getCommunity()?.id,
            treasury_id: treasuryId,
            date: data.date,
            amount: data.amount * (type === 'expense' ? -1 : 1),
            concept: data.concept
        }, {
            cancelToken: axiosCancelToken.token
        }).then((response) => {
            hideModal();
        }).catch((error) => {
            if (axios.isCancel(error)) {
                return;
            }

            toast.error('Ha ocurrido un error al guardar');

            const errors = error.response?.data?.errors ?? {};
            setErrors(errors);
        });	
        setLoading(false);
    }

    return (
        <AddManualMovementModalStyled id="add-manual-movement-modal-wrapper">
            <div className="modal" tabIndex="-1" ref={modalRef}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Añadir movimiento bancario</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <CustomInput label="Fecha" type="date" className="form-control form-control-sm" onChange={(e) => setDataField('date', e.target.value)} value={data.date ?? ''} />
                                        { errors.date &&
                                            <div className="invalid-feedback d-block">{ errors.date[0] }</div>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <CustomSelect label="Tipo" className="form-control form-control-sm" onChange={(e) => setType(e.target.value)} value={type ?? ''}>
                                            <option value="expense">Gasto</option>
                                            <option value="income">Ingreso</option>
                                        </CustomSelect>
                                    </div>
                                </div>
                                <div className="col col-md-4">
                                    <div className="mb-3">
                                        <CustomInput label="Importe" type="number" className="form-control form-control-sm" onChange={(e) => setDataField('amount', e.target.value)} value={data.amount ?? ''} />
                                        { errors.amount &&
                                            <div className="invalid-feedback d-block">{ errors.amount[0] }</div>
                                        }
                                    </div>
                                </div>
                                <div className="col col-md-12">
                                    <div className="mb-0">
                                        <CustomInput label="Concepto" type="text" className="form-control form-control-sm" onChange={(e) => setDataField('concept', e.target.value)} value={data.concept ?? ''} />
                                        { errors.concept &&
                                            <div className="invalid-feedback d-block">{ errors.concept[0] }</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-sm btn-primary text-white" onClick={() => saveData()} disabled={loading}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </AddManualMovementModalStyled>
    );
};

export default AddManualMovementModal;